class NewsletterPopup extends ModalDialog {
  constructor() {
    super();
    this.init();
    this.attachEventListeners();
  }

  // Moved all event listeners to a separate method for better organization
  attachEventListeners() {
    this.buttonClose = this.querySelector(".js-button-close");
    this.buttonClose.addEventListener("click", this.closeNewsletter.bind(this));

    if (this.form) {
      this.form.addEventListener("submit", this.onSubscribe.bind(this));
    }
  }

  init() {
    this.delay = this.dataset.delay * 1000;
    this.closed = getCookie("newsletter-closed");
    this.subscribed = getCookie("newsletter-subscribed");
    this.form = this.querySelector(".js-form");
    this.ageVerificationPopup = document.querySelector("age-verification-popup");
  }

  closeNewsletter() {
    this.hide();
  }

  // INAYAH: every dismissal (No thanks, Escape, overlay tap) must stick.
  // The base ModalDialog calls hide() directly for Escape/overlay, which
  // previously set no cookie - so the popup re-fired on every page view.
  // Cookies need an expiry too: without one they die with the session.
  hide() {
    if (this.hasAttribute("open") && !Shopify.designMode) {
      if (getCookie("newsletter-subscribed") !== "true") {
        setCookie("newsletter-closed", "true", 30);
      }
    }
    super.hide();
  }

  connectedCallback() {
    if (Shopify.designMode) {
      if (this.dataset.openInDesignMode === "true") {
      this.show();
      }
      return;
    }

    this.handlePopupVisibility();
  }

  handlePopupVisibility() {
    // INAYAH: after a successful signup Shopify redirects back with
    // ?customer_posted=true - reopen the popup (bypassing cookies and the
    // delay) so the success message with the discount code is visible.
    // The close button's "No thanks" label only makes sense before
    // subscribing, so swap it for the success label.
    if (window.location.search.indexOf("customer_posted=true") !== -1) {
      if (this.buttonClose && this.dataset.successCloseLabel) {
        this.buttonClose.textContent = this.dataset.successCloseLabel;
      }
      this.show();
      return;
    }

    if (getCookie("age-verified") !== "true" && this.ageVerificationPopup) {
      this.handleAgeVerificationPopup();
    } else {
      this.showPopupWithDelay();
    }
  }

  handleAgeVerificationPopup() {
    let prevClassState = this.classList.contains("newsletter-popup-is-hidden");

    const observer = new MutationObserver(mutations => {
      const mutation = mutations[0];
      if (mutation.attributeName !== "class") return;

      const currentClassState = mutation.target.classList.contains("newsletter-popup-is-hidden");

      if (prevClassState !== currentClassState) {
        prevClassState = currentClassState;
        if (!currentClassState) {
          this.showPopupWithDelay();
        }
      }
    });

    observer.observe(this, { attributes: true });
  }

  showPopupWithDelay() {
    setTimeout(() => {
      if (this.closed !== "true" && this.subscribed !== "true") {
        this.show();
      }
    }, this.delay);
  }

  onSubscribe() {
    setCookie("newsletter-subscribed", "true", 365);
    this.hide();
  }
}

customElements.define("newsletter-popup", NewsletterPopup);
